import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('elaraa_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const productsApi = {
  list: async (params = {}) => (await api.get('/products', { params })).data,
  get: async (id) => (await api.get(`/products/${id}`)).data,
};

export const authApi = {
  register: async (data) => (await api.post('/auth/register', data)).data,
  login: async (data) => (await api.post('/auth/login', data)).data,
  phoneLogin: async (data) => (await api.post('/auth/phone', data)).data,
  me: async () => (await api.get('/auth/me')).data,
  updateProfile: async (data) => (await api.put('/auth/me', data)).data,
  googleSession: async (session_id) =>
    (await api.post('/auth/google/session', {}, { headers: { 'X-Session-ID': session_id } })).data,
};

export const cartApi = {
  get: async () => (await api.get('/cart')).data,
  add: async (product_id, quantity = 1) => (await api.post('/cart', { product_id, quantity })).data,
  update: async (product_id, quantity) => (await api.put(`/cart/${product_id}`, { quantity })).data,
  remove: async (product_id) => (await api.delete(`/cart/${product_id}`)).data,
  clear: async () => (await api.delete('/cart')).data,
};

export const quizApi = {
  submit: async (answers) => (await api.post('/quiz', { answers })).data,
  history: async () => (await api.get('/quiz/history')).data,
};

export const ordersApi = {
  create: async (payload) => (await api.post('/orders', payload)).data,
  list: async () => (await api.get('/orders')).data,
};

export const paymentsApi = {
  createOrder: async (payload) => (await api.post('/payments/create-order', payload)).data,
  verify: async (payload) => (await api.post('/payments/verify', payload)).data,
};

export const couponsApi = {
  apply: async (payload) => (await api.post('/coupons/apply', payload)).data,
};

export const addressesApi = {
  list: async () => (await api.get('/addresses')).data,
  create: async (data) => (await api.post('/addresses', data)).data,
  update: async (id, data) => (await api.put(`/addresses/${id}`, data)).data,
  remove: async (id) => (await api.delete(`/addresses/${id}`)).data,
  setDefault: async (id) => (await api.put(`/addresses/${id}/default`)).data,
};

export const reviewsApi = {
  list: async (productId, params = {}) => (await api.get(`/products/${productId}/reviews`, { params })).data,
  summary: async (productId) => (await api.get(`/products/${productId}/reviews/summary`)).data,
  create: async (productId, data) => (await api.post(`/products/${productId}/reviews`, data)).data,
  toggleHelpful: async (reviewId) => (await api.post(`/reviews/${reviewId}/helpful`)).data,
  eligibility: async (productId) => (await api.get(`/my-reviews/eligibility/${productId}`)).data,
};

export const bannersApi = {
  list: async (placement) => (await api.get('/banners', { params: placement ? { placement } : {} })).data,
};

export const adminBannersApi = {
  list: async () => (await api.get('/admin/banners')).data,
  create: async (data) => (await api.post('/admin/banners', data)).data,
  update: async (id, data) => (await api.put(`/admin/banners/${id}`, data)).data,
  remove: async (id) => (await api.delete(`/admin/banners/${id}`)).data,
};

export const adminApi = {
  listProducts: async () => (await api.get('/admin/products')).data,
  createProduct: async (data) => (await api.post('/admin/products', data)).data,
  updateProduct: async (id, data) => (await api.put(`/admin/products/${id}`, data)).data,
  deleteProduct: async (id) => (await api.delete(`/admin/products/${id}`)).data,
  listOrders: async () => (await api.get('/admin/orders')).data,
  updateOrderStatus: async (id, status) => (await api.put(`/admin/orders/${id}/status`, { status })).data,
  listReviews: async (status) => (await api.get('/admin/reviews', { params: status ? { status } : {} })).data,
  updateReview: async (id, data) => (await api.put(`/admin/reviews/${id}`, data)).data,
  deleteReview: async (id) => (await api.delete(`/admin/reviews/${id}`)).data,
  getBestSellers: async () => (await api.get('/admin/best-sellers')).data,
  setBestSellers: async (product_ids) => (await api.put('/admin/best-sellers', { product_ids })).data,
  getWhatsApp: async () => (await api.get('/admin/whatsapp')).data,
  setWhatsApp: async (data) => (await api.put('/admin/whatsapp', data)).data,
  getAnnouncement: async () => (await api.get('/admin/announcement')).data,
  setAnnouncement: async (data) => (await api.put('/admin/announcement', data)).data,
  listUsers: async (search) => (await api.get('/admin/users', { params: search ? { search } : {} })).data,
  getUser: async (id) => (await api.get(`/admin/users/${id}`)).data,
  listCoupons: async () => (await api.get('/admin/coupons')).data,
  createCoupon: async (data) => (await api.post('/admin/coupons', data)).data,
  updateCoupon: async (id, data) => (await api.put(`/admin/coupons/${id}`, data)).data,
  deleteCoupon: async (id) => (await api.delete(`/admin/coupons/${id}`)).data,
};

export const bestSellersApi = {
  list: async () => (await api.get('/best-sellers')).data,
};

export const announcementApi = {
  get: async () => (await api.get('/announcement')).data,
};

export default api;
